import { gql } from "@apollo/client";

const WHATSAPP_PENDING_CALL_SIGNALING = gql`
  subscription whatsappPendingCallSignaling($mainSuperAdminId: ID!) {
    whatsappPendingCallSignaling(mainSuperAdminId: $mainSuperAdminId) {
      id
      callId
      inboxId
      agentId
      from
      customerName
      status
      sdpOffer
      direction
    }
  }
`;

export default WHATSAPP_PENDING_CALL_SIGNALING;
